import { withScope, setExtras, captureException, Scope } from '@sentry/nextjs';

import { captureEffectLogsSync } from './logging';
import { ErrorType } from '../types/sentry';

type SentryLogType = {
  path?: string;
  method?: string;
  error: ErrorType;
  action?: string;
  bypassSentry?: boolean;
  params?: Record<string, unknown>;
};

export const sentryLogAPIFailed = ({ error, params }: SentryLogType) => {
  return withScope((scope: Scope) => {
    scope.clear();
    scope.setTransactionName('API ERROR');

    const logEffect = captureEffectLogsSync({
      annotations: params,
      logLevel: error.logLevel,
      message: error.message,
    });

    setExtras({ requestBody: logEffect || {} });
    setExtras(error);

    const err =
      error instanceof Error
        ? error
        : new Error(JSON.stringify({ ...logEffect, ...error }));

    captureException(err);
  });
};
